import { IMapGeometry } from "~app/common/components/map/map.settings";
import { TplTransportavstandKartaComponent } from "../tpl-transportavstand-karta.component";

export class TplTransportavstandKartaLayers {

    constructor(
        readonly parent: TplTransportavstandKartaComponent) {}

    hoverIn(geometry: IMapGeometry, mouseevent: any) {
        if (geometry) {
            setTimeout(() => {
                this.parent.showTooltip(geometry, mouseevent.clientX, mouseevent.clientY);
            }, 20);
        }
    }

    hoverOut(geometry: IMapGeometry, mouseevent: any) {
        this.parent.hideTooltip();
    }
}
